<template>
    <div class="relative min-h-screen w-full flex bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto px-4 sm:px-8 py-6 w-full">
            <!-- Breadcrumb -->
            <nav class="text-sm text-gray-600 mb-6 flex">
                <router-link to="/dashboard" class="hover:text-blue-700 transition font-medium">Dashboard</router-link>
                <span class="mx-1">/</span>
                <span class="text-blue-900 font-semibold">Policies & Templates</span>
            </nav>

            <!-- Header -->
            <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                <div class="font-bold text-2xl text-gray-800">Policies & Templates Hub</div>
                <p class="text-gray-600 mt-2">
                    Access and manage institutional templates alongside policies, processes, and procedures.
                </p>
            </div>

            <!-- Tabs -->
            <div class="mt-8">
                <div class="bg-white rounded-2xl border shadow-lg mb-6">
                    <div class="flex border-b flex-col sm:flex-row">
                        <button v-for="tab in tabs" :key="tab.key" @click="setActiveTab(tab.key)"
                            :class="tabButtonClasses(tab.key)"
                            class="flex-1 px-6 py-4 text-sm font-medium transition-colors duration-200 flex items-center justify-center space-x-2">
                            <font-awesome-icon :icon="tab.icon" />
                            <span>{{ tab.label }}</span>
                        </button>
                    </div>
                </div>

                <!-- Tab Content -->
                <div class="tab-content">
                    <keep-alive>
                        <component :is="activeTabComponent" :hide-breadcrumb="true" />
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TemplatePage from '../template/index.vue';
import PolicyProcessesAndProcedures from '../policies-processes-and-procedures/index.vue';

export default {
    name: 'PoliciesAndTemplates',
    components: {
        TemplatePage,
        PolicyProcessesAndProcedures
    },
    data() {
        return {
            activeTab: 'templates',
            tabs: [
                { key: 'templates', label: 'Templates', icon: 'file-alt' },
                { key: 'policies', label: 'Policies', icon: 'university' }
            ]
        };
    },
    computed: {
        activeTabComponent() {
            if (this.activeTab === 'templates') {
                return TemplatePage;
            }
            return PolicyProcessesAndProcedures;
        }
    },
    methods: {
        setActiveTab(tabKey) {
            this.activeTab = tabKey;
        },
        tabButtonClasses(tabKey) {
            let classes = '';
            if (tabKey === 'templates') {
                classes += ' rounded-l-2xl';
            }
            if (tabKey === 'policies') {
                classes += ' rounded-r-2xl';
            }
            if (this.activeTab === tabKey) {
                classes += ' text-blue-600 border-b-2 border-blue-600 bg-blue-50';
            } else {
                classes += ' text-gray-500 hover:text-gray-700 hover:bg-gray-50';
            }
            return classes.trim();
        }
    }
};
</script>

<style scoped>
.tab-content {
    min-height: 200px;
}

button {
    border-right: 1px solid rgba(229, 231, 235, 1);
}

button:last-child {
    border-right: none;
}

@media (max-width: 640px) {
    button {
        border-right: none;
        border-bottom: 1px solid rgba(229, 231, 235, 1);
    }

    button:last-child {
        border-bottom: none;
    }
}
</style>
